export default __webpack_public_path__ + "static/fakegoogle_3-464abb8de84de76df75e0b708babd39d.jpg";